import React from 'react';

const SearchBgTriangle = ({className}) => (
  <svg className={className} viewBox="0 0 297 414" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M297 413.999C207 377.5 10.9998 210.002 0 1C252 0.994216 251.195 0.999488 263 0.999488C268.554 0.999386 269.723 0.849059 272.5 1.49882C275.5 1.99882 278.392 3.19498 281 4.49882C283 5.49882 286 7.49882 288.5 9.99882C290.279 12.0315 292.5 14.4988 294 17.9988C294.5 18.4988 296 22.4988 296.589 25.7129C296.836 27.5447 297 28.4988 297 32.4995C297 32.4995 297 217.604 297 413.999Z" fill="#5468FF" fillOpacity="0.3"/>
  </svg>
);

export default SearchBgTriangle;
